export default "__VITE_ASSET__Be3C7a5s__"